/**
 * Widget Click Event Handleing
 */
const $ = jQuery;
const { archiveWidget, categoryWidget } = window.embark;
const itemsToShow = 10;
const widgetList = {
	archive: document.querySelector('.widget.widget_categories'),
	category: document.querySelector('.widget.widget_archive'),
};

/**
 * Sets button text based on parameter for toggle.
 *
 * @param {string} widgetType
 * @param {string} displayType
 */
const setWidgetButtonText = (widgetType, displayType) => {
	let more;
	let less;

	switch (widgetType) {
		case 'archive':
			more = archiveWidget.viewMoreTxt;
			less = archiveWidget.viewLessTxt;
			break;
		case 'category':
			more = categoryWidget.viewMoreTxt;
			less = categoryWidget.viewLessTxt;
			break;
		default:
			break;
	}
	return displayType === 'show' ? more : less;
};

function widgetAddViewMoreButton() {
	Object.entries(widgetList).forEach((widgets) => {
		/**
		 * Create Buttons
		 */
		const button = document.createElement('button');
		button.className = 'view-more-button';
		let text = document.createTextNode('View More');

		if (widgets[0] !== null) {
			switch (widgets[0]) {
				case 'archive':
					text = document.createTextNode(archiveWidget.viewMoreTxt);
					break;
				case 'category':
					text = document.createTextNode(categoryWidget.viewMoreTxt);
					break;
				default:
					break;
			}
		}

		/**
		 * Add text to button.
		 */
		button.appendChild(text);

		/** Create new ul list for hidden elements */
		const container = document.createElement('ul');
		container.style.display = 'none';

		if (widgets[1] !== null) {
			const widget = widgets[1];

			if (widget.querySelectorAll('ul').length) {
				/**
				 * Add created elements to widget.
				 */
				widget.appendChild(container);
				widget.appendChild(button);

				const items = widget.querySelectorAll('ul li');
				if (items) {
					const hiddenItems = [];
					items.forEach((item, i) => {
						if (i >= itemsToShow) {
							hiddenItems.push(item);
						}
					});

					hiddenItems.forEach((hiddenItem) => {
						container.appendChild(hiddenItem);
					});
				}

				/**
				 * Add Click Handling
				 */
				widget.querySelector('.view-more-button').addEventListener('click', (e) => {
					const parent = e.target.parentNode;

					/**
					 * Toggle Event
					 */
					if (parent.classList.contains('view')) {
						e.target.innerText = setWidgetButtonText(widgets[0], 'show');
						parent.classList.remove('view');
					} else {
						e.target.innerText = setWidgetButtonText(widgets[0], 'no-show');
						parent.classList.add('view');
					}

					$(container).slideToggle();
				});
			}
		}
	});
}

document.addEventListener('DOMContentLoaded', widgetAddViewMoreButton);
